import { useEffect } from "react";

import { ANNUAL_CAMPAIGN_ID } from "app/components/AnnualPromoModal/configs/buildAnnualCampaignConfig";
import { DiscountBanner } from "app/components/discountCampaign/DiscountBanner/DiscountBanner";
import { FIRST_WEEK_CAMPAIGN_ID } from "app/components/FirstWeekMonthlyPromo/configs/buildFirstWeekDiscountCampaignConfig";
import { useDiscounts } from "app/components/hooks/useDiscounts";
import { allTrackers } from "app/services/track/track";

const campaignBannerShowEventNamesMap = {
    [FIRST_WEEK_CAMPAIGN_ID]: "Discount Banner/First Week Discount",
    [ANNUAL_CAMPAIGN_ID]: "Discount Banner/4 months upgrade",
} as const;

export const DiscountPageTopBanner = () => {
    const { discountBannerProps, activeCampaignId } = useDiscounts();
    const isTrackedBannerCampaign =
        activeCampaignId === FIRST_WEEK_CAMPAIGN_ID || activeCampaignId === ANNUAL_CAMPAIGN_ID;
    const bannerShowEventName =
        discountBannerProps !== null && activeCampaignId && isTrackedBannerCampaign
            ? campaignBannerShowEventNamesMap[activeCampaignId]
            : undefined;

    useEffect(() => {
        if (bannerShowEventName !== undefined) {
            allTrackers.dispatchTrackEvent("Banner", "show", bannerShowEventName);
        }
    }, [bannerShowEventName]);

    if (!discountBannerProps) {
        return null;
    }

    return <DiscountBanner {...discountBannerProps} />;
};
